import * as React from 'react';
import { cn } from '@/lib/utils';

type Tone = 'default' | 'good' | 'warn' | 'critical' | 'offline' | 'inflight' | 'accent';

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
}

const tones: Record<Tone, string> = {
  default: 'bg-surface-2 text-fg-secondary border-border-default',
  good: 'bg-status-good/15 text-status-good border-status-good/40',
  warn: 'bg-status-warn/15 text-status-warn border-status-warn/40',
  critical: 'bg-status-critical/15 text-status-critical border-status-critical/40',
  offline: 'bg-surface-2 text-status-offline border-border-default',
  inflight: 'bg-status-inflight/15 text-status-inflight border-status-inflight/40',
  accent: 'bg-accent/15 text-accent border-accent/40',
};

export function Badge({ className, tone = 'default', ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded border px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide',
        tones[tone],
        className,
      )}
      {...props}
    />
  );
}
